//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import { mapGetters } from 'vuex';
import Confirm from '../../shared-components/vuetify/dialog/Confirm';
import AnoFiscalTipoEvento from './AnoFiscalTipoEvento';

export default {
  name: 'AnoFiscalCard',
  mixins: [AnoFiscalTipoEvento],
  components: {
    Confirm,
  },
  data() {
    return {
      index: 1,
      message: '',
      ano: {},
      periodo: {},
      anos: [],
      acaoFechar: () => { },
      resourcesAnoFiscal: this.$api.anoFiscal(this.$resource),
      resourcesOrcamentoTipoVerba: this.$api.orcamentoTipoVerba(this.$resource),
      headers: [
        { text: this.$t('label.descricao'), value: 'descricao', sortable: false },
        { text: this.$t('label.data_inicio'), value: 'dataInicio', sortable: false },
        { text: this.$t('label.data_fim'), value: 'dataFim', sortable: false },
      ],
    };
  },
  props: {
    tipoVerba: null,
    habilitarBloqueio: {
      type: Boolean,
      default: false,
    },
    habilitarFechamento: {
      type: Boolean,
      default: false,
    },
    habilitarPeriodosOrcamento: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canPeriodoFiscal() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'PERIODO_FISCAL').length;
    },
    headersPeriodo() {
      const headers = Object.assign([], this.headers);
      if (this.canPeriodoFiscal) {
        headers.push({ text: '', value: 'acoes', sortable: false });
      }
      return headers;
    },
    exibirNovo() {
      return this.index >= this.anos.length;
    },
    anoFiscal() {
      if (this.exibirNovo) return { descricao: this.$tc('label.novo', 1) };
      return this.anos[this.index];
    },
    anoFiscalBloqueado() {
      return this.anoFiscal.status === 'VIGENTE_COM_BLOQUEIO';
    },
    anoFiscalVigente() {
      return this.anoFiscal.status === 'VIGENTE_COM_BLOQUEIO'
        || this.anoFiscal.status === 'VIGENTE';
    },
    traduzStatus() {
      return this.$tc(`label.status_ano_fiscal.${this.anoFiscal.status}`, 1);
    },
    habilitarVoltar() {
      return this.index > 0 && !!this.anos.length;
    },
    habilitarProximo() {
      return this.index < this.anos.length;
    },
    temProximo() {
      return this.index < this.anos.length - 1;
    },
  },
  methods: {
    periodoVigente(status) {
      return status === 'VIGENTE_COM_BLOQUEIO' || status === 'VIGENTE';
    },
    periodoBloqueado(status) {
      return status === 'VIGENTE_COM_BLOQUEIO';
    },
    tratarStatus(status) {
      return this.$tc(`label.status_ano_fiscal.${status}`, 1);
    },
    voltarAno() {
      this.index = this.index - 1;
    },
    proximoAno() {
      this.index = this.index + 1;
    },
    formatarData(valor) {
      return moment(valor).format('DD/MM/YYYY');
    },
    carregarAnoFiscal() {
      if (!this.tipoVerba) return;
      this.idTipoVerba = this.tipoVerba.id;
      if (!this.naoLimparMensagem) {
        this.mensagem = '';
      }
      this.naoLimparMensagem = false;
      this.resourcesAnoFiscal.pesquisarPorTipo({ idTipoVerba: this.tipoVerba.id })
        .then(this.tratarRetorno)
        .catch((err) => {
          this.$error(this, err);
        });
    },
    tratarRetorno(res) {
      this.anos = res.body;
      this.anos.forEach((a, i) => {
        if (a.status === 'VIGENTE'
          || a.status === 'VIGENTE_COM_BLOQUEIO') this.index = i;
      });
    },
    fecharPeriodoAno() {
      this.fecharPeriodo(this.tipoVerba.id, this.periodo.id);
    },
    fecharPeriodoConfirmacao(item) {
      this.periodo = item;
      this.acaoFechar = this.fecharPeriodoAno;
      this.message = this.$t('message.fechamento_periodo_fiscal');
      this.$refs.confirmDialog.open();
    },
    fecharAno() {
      if (this.temProximo) {
        this.fecharAnoFiscal(this.tipoVerba.id, this.ano.id);
      } else {
        this.novo('novoFecharAnoFiscal', this.ano.id);
      }
    },
    fecharConfirmacao(item) {
      this.ano = item;
      this.acaoFechar = this.fecharAno;
      this.message = this.$t('message.fechamento_ano_fiscal');
      this.$refs.confirmDialog.open();
    },
    novo(rota, idAnoFechar) {
      const param = {
        name: rota,
        params: {
          tipo: this.tipoVerba.id,
        },
      };
      if (idAnoFechar) {
        param.params.idAnoFechar = idAnoFechar;
      }
      this.$router.push(param);
    },
  },
  mounted() {
    this.carregarAnoFiscal();
  },
};



// WEBPACK FOOTER //
// ./src/spa/ano-fiscal/AnoFiscalCard.vue?vue&type=script&lang=js&